module.exports = __webpack_public_path__ + "media/openBox.9c98b379.mp3";